module.exports = __webpack_public_path__ + "static/01BANNER-11-8fe8e4b8ae33f73aa8d86c426efc66b0.png";